import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import {
   appendTestableElementAttributes,
   LabeledColorDot,
   LabeledColorDotSize,
   StyledFlex,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';
import { createTranslatedText, Translate, useTranslate } from '@dreryk/react-common';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';

import { visitPatientDetailsKeys } from '../../../../../../translations';

import { StyledPatientAutosuggestItemDetails } from './PatientAutosuggestItemDetails.styled';

type PatientAutosuggestItemDetailsProps = { patient: PatientSimple };

export const PatientAutosuggestItemDetails = (props: PatientAutosuggestItemDetailsProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledPatientAutosuggestItemDetails
         direction={'row'}
         flexWrap={'wrap'}
         {...appendTestableElementAttributes('details')}
      >
         <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
            {props.patient.referenceIdentifier ? (
               <Translate>{getPatientReferenceIdentifierTranslatableText(props.patient.referenceIdentifier)}</Translate>
            ) : null}

            {props.patient.phoneNumber ? (
               <span>
                  {translate(visitPatientDetailsKeys.phoneAbbreviation)} {props.patient.phoneNumber.asString()}
               </span>
            ) : null}
         </TextSeparator>

         {props.patient.patientGroups.length ? (
            <>
               {/* TODO DREGAB-21847 */}
               <Text testId={'separator'} whiteSpaces={'break-spaces'}>
                  {TextSeparatorType.COMMA_SPACE}
               </Text>

               {props.patient.patientGroups.map(({ id, name, primaryColor, darkModeColor }, index) => {
                  const lastElement = props.patient.patientGroups.length - 1 === index;
                  return (
                     <StyledFlex key={id}>
                        <LabeledColorDot
                           key={id}
                           color={primaryColor.asHexString()}
                           darkColor={darkModeColor?.asHexString()}
                           label={createTranslatedText(name)}
                           size={LabeledColorDotSize.SMALLEST}
                           testId={`patientGroup-${id}`}
                        />
                        {lastElement ? null : (
                           // TODO DREGAB-21847
                           <Text testId={'separator'} whiteSpaces={'break-spaces'}>
                              {TextSeparatorType.COMMA_SPACE}
                           </Text>
                        )}
                     </StyledFlex>
                  );
               })}
            </>
         ) : null}
      </StyledPatientAutosuggestItemDetails>
   );
};
